import { useMemo } from "react";

export default usePipelineNodeExecution;

function usePipelineNodeExecution(id, isPreviewMode, getNodeExecution) {
  const { isExecuted, executedNode, executedNodeStatus } = useMemo(() => {
    if (!isPreviewMode) {
      return {
        isExecuted: false,
        executedNode: null,
        executedNodeStatus: "none",
      };
    }

    const nodeExecution = getNodeExecution(id);

    console.log({nodeExecution})

    return {
      ...nodeExecution,
      executedNodeStatus: nodeExecution?.executedNode?.status ?? "none",
    };
  }, [isPreviewMode, getNodeExecution, id]);

  return {
    isExecuted,
    executedNode,
    executedNodeStatus,
  };
}
